'use client';

var _excluded = ["html", "onError", "onPlay"],
  _excluded2 = ["html"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { forwardRef, memo, useEffect, useMemo, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var IFRAMELY_EMBED_SCRIPT_SRC = '//cdn.iframe.ly/embed.js';
export function HtmlInjection(props) {
  var {
      html,
      onError,
      onPlay
    } = props,
    attrs = _objectWithoutProperties(props, _excluded);
  var containerRef = useRef(null);
  var strippedHtml = useScripts(html, onError);
  useEffect(() => {
    if (!containerRef.current || !onPlay) {
      return;
    }
    import('player.js').then(playerjs => {
      var _containerRef$current;
      var nodes = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getElementsByTagName('iframe');
      var iframes = Array.from(nodes !== null && nodes !== void 0 ? nodes : []);
      iframes.forEach(iframe => {
        iframe.addEventListener('load', () => {
          var player = new playerjs.Player(iframe);
          player.on('play', onPlay);
        });
      });
    });
  }, [onPlay, strippedHtml]);
  return /*#__PURE__*/_jsx(MemoHtml, _objectSpread(_objectSpread({
    ref: containerRef
  }, attrs), {}, {
    html: strippedHtml
  }));
}
var MemoHtml = /*#__PURE__*/memo(/*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      html
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: ref
  }, restProps), {}, {
    dangerouslySetInnerHTML: {
      __html: html
    }
  }));
}));
MemoHtml.displayName = 'MemoHtml';
function useScripts(html, onError) {
  var [strippedHtml, scriptsAttributes] = useMemo(() => {
    if (typeof document === 'undefined') {
      return [html, []];
    }
    var container = document.createElement('div');
    container.innerHTML = html;
    var scripts = Array.from(container.getElementsByTagName('script'));
    var attributes = scripts.map(script => Array.from(script.attributes).reduce((agg, _ref2) => {
      var {
        name,
        value
      } = _ref2;
      return _objectSpread(_objectSpread({}, agg), {}, {
        [name]: value
      });
    }, {}));
    scripts.forEach(script => script.remove());
    var resultHtml = container.innerHTML;
    container.remove();
    return [resultHtml, attributes];
  }, [html]);
  useEffect(() => {
    scriptsAttributes.forEach(attributes => {
      if (attributes.src && document.querySelector("script[src=\"".concat(attributes.src, "\"]"))) {
        return;
      }
      var script = document.createElement('script');
      setScriptAttributes(script, attributes);
      script.addEventListener('error', onError);

      // Iframely docs advise to insert their embed script before other scripts
      if (attributes.src === IFRAMELY_EMBED_SCRIPT_SRC) {
        var firstScript = document.querySelectorAll('body > script')[0];
        if (firstScript && firstScript.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
          return;
        }
      }
      document.body.appendChild(script);
    });
    if (typeof iframely !== 'undefined') {
      iframely.load();
    }
    // TODO: Address this. Simply adding `onError` to the deps might introduce an infinite loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scriptsAttributes]);
  return strippedHtml;
}
function setScriptAttributes(script, attributes) {
  Object.entries(attributes).forEach(_ref3 => {
    var [name, value] = _ref3;
    return script.setAttribute(name, value);
  });
}